/**
 * WP Tutorials : Customise WooCommerce Shipping Rates Layout, CWSRL
 *
 * https://wp-tutorials.tech/refine-wordpress/woocommerce-shipping-methods-as-a-dropdown-list/
 */
(function($) {
    'use strict';
    $(window).on('load', function() {
        // Diagnostics
        // console.log(`CWSRL: load (dropdown)`);
        function updateShippingMethodsDropdown() {
            // Diagnostics
            // console.log('updateShippingMethodsDropdown()');
            const radioInputs = $('#shipping_method input[type="radio"].shipping_method');
            const shippingMethodContainer = $(radioInputs).closest('#shipping_method');
            const radioInputCount = $(radioInputs).length;
            const shippingMethodTableCell = $(shippingMethodContainer).closest('td');
            // If there exists a drop-down list form a previous iteration,
            // get rid of it now.
            $(shippingMethodTableCell).find('.wpt-shipping-methods').remove();
            if (radioInputCount > 0) {
                // Create a new drop-down list.
                const select = $('<select class="wpt-shipping-methods"></select>');
                $(shippingMethodTableCell).append(select);
                $(radioInputs).each(function(index, el) {
                    const radioInput = $(this);
                    const listItem = $(this).closest('li');
                    const shippingMethodLabel = $(listItem).find('label');
                    // Diagnostics
                    // console.log(shippingMethodLabel.text());
                    // Create an option and append it to our drop-down list, using
                    // the value and text of the radio button and its label.
                    const shippingMethodOption = $('<option></option>');
                    shippingMethodOption.text(shippingMethodLabel.text());
                    shippingMethodOption.val(radioInput.val());
                    $(select).append(shippingMethodOption);
                    if (radioInput.is(':checked')) {
                        $(select).val(radioInput.val());
                    }
                });
                $(select).change(function(event) {
                    const newValue = $(this).val();
                    // Diagnostics
                    // console.log(`Change: ${newValue}`);
                    $(`input[value="${newValue}"]`).trigger('click');
                });
            }
        }
        /**
         * When WooCommerce fires the updated_checkout event, we need to rescan
         * for shipping method radio buttons and destroy/recreate our drop-down list.
         */
        $(document.body).on('updated_checkout', function() {
            // Diagnostics.
            // console.log('updated_checkout');
            updateShippingMethodsDropdown();
        });
    });
})(jQuery);